var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingSpinnerBar col-12 mt-4 pt-4"},[(_vm.loadingText)?_c('small',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.loadingText))]):_vm._e(),_vm._m(0),_c('img',{staticClass:"logooliver",attrs:{"src":require("@/assets/images/logo-h.png")}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linear-progress"},[_c('div',{staticClass:"bar bar1"}),_c('div',{staticClass:"bar bar2"})])
}]

export { render, staticRenderFns }